// src/pages/test/utils/ipfs.ts
import { getIpfsGatewayUrl } from "../../../utils/ipfsConfig";

/**
 * Builds IPFS URL from hash using configured gateway
 * @param hash - The IPFS hash or complete URL
 * @param tenantGatewayUrl - Optional tenant-specific gateway URL override
 * @returns Complete IPFS URL with proper protocol
 */
export const buildIPFSUrl = (hash: string, tenantGatewayUrl?: string): string => {
  if (!hash) return '';

  if (hash.startsWith('http://') || hash.startsWith('https://')) {
    return hash;
  }

  const gatewayBase = tenantGatewayUrl || getIpfsGatewayUrl();

  const cleanHash = hash.startsWith('/') ? hash.slice(1) : hash;

  return `${gatewayBase}/${cleanHash}`;
};
